export const CAKE_TEST_IDS = {
    SELECT_HALF_CARD: "cake-select-half-card",
    CAKE_MESSAGE_HALF_CARD: "cake-message-half-card",
    CAKE_MESSAGE_INPUT: "cake-message-input",
    CAKE_MESSAGE_CONFIRM_BUTTON: "cake-message-confirm-button",
};
